import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChecklistRtlIcon(props: IconProps) {
    return <Icon {...props} iconKey={"checklist_rtl"}/>
}
